<div class="table-responsive">
    <table class="table table-borderless table-hover">
        <thead>
            <tr>
                <th>S.No.</th>
                <th *ngFor="let head of header">{{head.label}}</th>
            </tr>
        </thead>
        <tbody>
            <tr class="border-bottom" *ngFor="let data of tableData; let rowIndex = index">
                <td>{{rowIndex+1}}</td>

                <td *ngFor="let head of header">
                  <ng-container *ngIf="head.key != 'loanType'; else default">{{data[head.key]}}</ng-container>
                  <ng-template #default>{{loanType[data[head.key]]}}</ng-template>

                  </td>
            </tr>
        </tbody>
    </table>
</div>
